import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CQMSDashBoardCalcDispaly } from 'src/app/models/CQMSDashBoardCalcDisplay';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-numerator-patients',
  templateUrl: './numerator-patients.component.html',
  styleUrls: ['./numerator-patients.component.css']
})
export class NumeratorPatientsComponent implements OnInit {

  displayedColumns: string[] = ['pid', 'pname', 'dob',];
  dataSource = new MatTableDataSource();

  constructor(
    public dialogRef: MatDialogRef<NumeratorPatientsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CQMSDashBoardCalcDispaly) {}

  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit() {
    this.loadNumeratorPats();
  }

  loadNumeratorPats(){
    this.dataSource.data = this.data.patNumeratorList;
  }

}
